module.exports = __webpack_public_path__ + "a0fc85125bbbde8dcb26f6b1f2b3bd4e.svg";